export default (state) => state.uberToken;
